import { z } from "zod";

import { communitySchema } from "../communitySchema";

export const communitiesChildrenSchema = z.object({
  total: z.number(),
  results: z.array(communitySchema),
});

export type CommunitiesChildren = z.infer<typeof communitiesChildrenSchema>;
